import { gql } from '@apollo/client'

export const GET_ALL_USER_APP = gql`
  query GetAllUserApp(
    $searchQuery: String
    $limit: Int
    $offset: Int
    $filters: filtersUserApp
  ) {
    getAllUserApp(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
      filters: $filters
    ) {
      rows {
        id
        name
        first_name
        last_name
        email
        phone
        address
        suspended
        suspended_by
        suspended_at
        suspended_reason
        UserSuspendedOfUserApp {
          name
          first_name
          last_name
        }
      }
      count
    }
  }
`

export const GET_ONE_USER_APP_BY_ID = gql`
  query GetOneUserAppById($id: Int!) {
    userApp: getOneUserAppById(id: $id) {
      id
      name
      first_name
      last_name
      email
      phone
      address
      suspended
      suspended_by
      suspended_at
      suspended_reason
    }
  }
`

export const GET_ALL_USERS_APP_SEARCH = gql`
  mutation GetAllUserAppBySearch($search: String!) {
    getAllUserAppBySearch(search: $search) {
      id
      name
      email
      phone
      address
    }
  }
`

export const APPLY_SUSPENSION_USER_APP = gql`
  mutation ApplySuspensionUserApp($id: Int!, $reason: String!) {
    applySuspensionUserApp(id: $id, reason: $reason)
  }
`

export const REMOVE_SUSPENSION_USER_APP = gql`
  mutation RemoveSuspensionUserApp($id: Int!) {
    removeSuspensionUserApp(id: $id)
  }
`
